export const countries = {
  AD: "Andorre",
  AE: "Émirats arabes unis (les)",
  AF: "Afghanistan",
  AG: "Antigua-et-Barbuda",
  AI: "Anguilla",
  AL: "Albanie",
  AM: "Arménie",
  AO: "Angola",
  AQ: "Antarctique",
  AR: "Argentine",
  AS: "Samoa américaines",
  AT: "Autriche",
  AU: "Australie",
  AW: "Aruba",
  AX: "Îles Åland",
  AZ: "Azerbaïdjan",
  BA: "Bosnie-Herzégovine",
  BB: "Barbade",
  BD: "Bangladesh",
  BE: "Belgique",
  BF: "Burkina Faso",
  BG: "Bulgarie",
  BH: "Bahreïn",
  BI: "Burundi",
  BJ: "Bénin",
  BL: "Saint-Barthélemy",
  BM: "Bermudes",
  BN: "Brunei Darussalam",
  BO: "Bolivie (État plurinational de)",
  BQ: "Bonaire, Saint-Eustache et Saba",
  BR: "Brésil",
  BS: "Bahamas (les)",
  BT: "Bhoutan",
  BV: "Île Bouvet",
  BW: "Botswana",
  BY: "Bélarus",
  BZ: "Belize",
  CA: "Canada",
  CC: "Îles Cocos (Keeling) (les)",
  CD: "Congo (République démocratique du)",
  CF: "République centrafricaine (la)",
  CG: "Congo (le)",
  CH: "Suisse",
  CI: "Côte d'Ivoire",
  CK: "Îles Cook (les)",
  CL: "Chili",
  CM: "Cameroun",
  CN: "Chine",
  CO: "Colombie",
  CR: "Costa Rica",
  CU: "Cuba",
  CV: "Cabo Verde",
  CW: "Curaçao",
  CX: "Île Christmas",
  CY: "Chypre",
  CZ: "Tchéquie",
  DE: "Allemagne",
  DJ: "Djibouti",
  DK: "Danemark",
  DM: "Dominique",
  DO: "République dominicaine (la)",
  DZ: "Algérie",
  EC: "Équateur",
  EE: "Estonie",
  EG: "Égypte",
  EH: "Sahara occidental*",
  ER: "Érythrée",
  ES: "Espagne",
  ET: "Éthiopie",
  FI: "Finlande",
  FJ: "Fidji",
  FK: "Îles Malouines (les) [Malvinas]",
  FM: "Micronésie (États fédérés de)",
  FO: "Îles Féroé (les)",
  FR: "France",
  GA: "Gabon",
  GB: "Royaume-Uni de Grande-Bretagne et d'Irlande du Nord (le)",
  GD: "Grenade",
  GE: "Géorgie",
  GF: "Guyane française",
  GG: "Guernesey",
  GH: "Ghana",
  GI: "Gibraltar",
  GL: "Groenland",
  GM: "Gambie (la)",
  GN: "Guinée",
  GP: "Guadeloupe",
  GQ: "Guinée équatoriale",
  GR: "Grèce",
  GS: "Géorgie du Sud-et-les Îles Sandwich du Sud",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinée-Bissau",
  GY: "Guyana",
  HK: "Hong Kong",
  HM: "Île Heard-et-Îles MacDonald",
  HN: "Honduras",
  HR: "Croatie",
  HT: "Haïti",
  HU: "Hongrie",
  ID: "Indonésie",
  IE: "Irlande",
  IL: "Israël",
  IM: "Île de Man",
  IN: "Inde",
  IO: "Territoire britannique de l'océan Indien (le)",
  IQ: "Iraq",
  IR: "Iran (République islamique d')",
  IS: "Islande",
  IT: "Italie",
  JE: "Jersey",
  JM: "Jamaïque",
  JO: "Jordanie",
  JP: "Japon",
  KE: "Kenya",
  KG: "Kirghizistan",
  KH: "Cambodge",
  KI: "Kiribati",
  KM: "Comores (les)",
  KN: "Saint-Kitts-et-Nevis",
  KP: "Corée (République populaire démocratique de)",
  KR: "Corée (République de)",
  KW: "Koweït",
  KY: "Îles Caïmans (les)",
  KZ: "Kazakhstan",
  LA: "République démocratique populaire lao (la)",
  LB: "Liban",
  LC: "Sainte-Lucie",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Libéria",
  LS: "Lesotho",
  LT: "Lituanie",
  LU: "Luxembourg",
  LV: "Lettonie",
  LY: "Libye",
  MA: "Maroc",
  MC: "Monaco",
  MD: "Moldova (République de)",
  ME: "Monténégro",
  MF: "Saint-Martin (partie française)",
  MG: "Madagascar",
  MH: "Îles Marshall (les)",
  MK: "Macédoine du Nord",
  ML: "Mali",
  MM: "Myanmar",
  MN: "Mongolie",
  MO: "Macao",
  MP: "Îles Mariannes du Nord (les)",
  MQ: "Martinique",
  MR: "Mauritanie",
  MS: "Montserrat",
  MT: "Malte",
  MU: "Maurice",
  MV: "Maldives",
  MW: "Malawi",
  MX: "Mexique",
  MY: "Malaisie",
  MZ: "Mozambique",
  NA: "Namibie",
  NC: "Nouvelle-Calédonie",
  NE: "Niger (le)",
  NF: "Île Norfolk",
  NG: "Nigéria",
  NI: "Nicaragua",
  NL: "Pays-Bas (Royaume des)",
  NO: "Norvège",
  NP: "Népal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Nouvelle-Zélande",
  OM: "Oman",
  PA: "Panama",
  PE: "Pérou",
  PF: "Polynésie française",
  PG: "Papouasie-Nouvelle-Guinée",
  PH: "Philippines (les)",
  PK: "Pakistan",
  PL: "Pologne",
  PM: "Saint-Pierre-et-Miquelon",
  PN: "Pitcairn",
  PR: "Porto Rico",
  PS: "Palestine, État de",
  PT: "Portugal",
  PW: "Palaos",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "La Réunion",
  RO: "Roumanie",
  RS: "Serbie",
  RU: "Fédération de Russie (la)",
  RW: "Rwanda",
  SA: "Arabie saoudite",
  SB: "Îles Salomon",
  SC: "Seychelles",
  SD: "Soudan (le)",
  SE: "Suède",
  SG: "Singapour",
  SH: "Sainte-Hélène, Ascension et Tristan da Cunha",
  SI: "Slovénie",
  SJ: "Svalbard et Jan Mayen",
  SK: "Slovaquie",
  SL: "Sierra Leone",
  SM: "Saint-Marin",
  SN: "Sénégal",
  SO: "Somalie",
  SR: "Suriname",
  SS: "Soudan du Sud",
  ST: "Sao Tomé-et-Principe",
  SV: "El Salvador",
  SX: "Saint-Martin (partie néerlandaise)",
  SY: "République arabe syrienne (la)",
  SZ: "Eswatini",
  TC: "Îles Turques-et-Caïques (les)",
  TD: "Tchad",
  TF: "Terres australes françaises (les)",
  TG: "Togo",
  TH: "Thaïlande",
  TJ: "Tadjikistan",
  TK: "Tokelau",
  TL: "Timor-Leste",
  TM: "Turkménistan",
  TN: "Tunisie",
  TO: "Tonga",
  TR: "Türkiye",
  TT: "Trinité-et-Tobago",
  TV: "Tuvalu",
  TW: "Taïwan (Province de Chine)",
  TZ: "Tanzanie, République-Unie de",
  UA: "Ukraine",
  UG: "Ouganda",
  UM: "Îles mineures éloignées des États-Unis (les)",
  US: "États-Unis d'Amérique (les)",
  UY: "Uruguay",
  UZ: "Ouzbékistan",
  VA: "Saint-Siège (le)",
  VC: "Saint-Vincent-et-les-Grenadines",
  VE: "Venezuela (République bolivarienne du)",
  VG: "Îles Vierges britanniques",
  VI: "Îles Vierges des États-Unis",
  VN: "Viet Nam",
  VU: "Vanuatu",
  WF: "Wallis-et-Futuna",
  WS: "Samoa",
  YE: "Yémen",
  YT: "Mayotte",
  ZA: "Afrique du Sud",
  ZM: "Zambie",
  ZW: "Zimbabwe",
} as const;
